import { Skeleton } from '@/components/atoms/Skeleton';
import useBreakpoint from '@/hooks/useBreakpoint';
import { theme } from '@/styles/theme';

export default function MinhaCarteiraDetalhamentoFallback() {
  const { breakpoint } = useBreakpoint();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: breakpoint === 'mobile' ? 'column' : 'row',
        gap: theme.spacing[breakpoint === 'mobile' ? 6 : 4],
        height: breakpoint === 'desktop' ? 280 : 'auto',
      }}
    >
      <Skeleton style={{ height: 280, flex: 1 }} />
      <Skeleton style={{ height: 280, flex: 1, flexGrow: 2 }} />
    </div>
  );
}
